import {useEffect} from 'react';

/**
 * @FIXME
 * Should be implemented with `useNavigate()` and `useLocation()` from react-router.
 * The reason we don't at the moment is that the router-state change causes almost everything to re-render,
 * which is problematic for user triggered events (we want instant feedback).
 * To resolve look where this hook gets used, have the react-profiler open and trigger the hooks behavior
 * and look for unexpected re-renders and fix them.
 */
export const useOverlayState = ({
  id,
  enabled = true,
  onChange,
}: {
  id: string;
  enabled?: boolean;
  onChange: () => void;
}) => {
  useEffect(() => {
    const handlePopState: WindowEventHandlers['onpopstate'] = () => {
      if (enabled && window.location.hash === '') {
        onChange();
      }
    };
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [enabled, onChange]);

  if (enabled === false) {
    return {
      store() {
        // noop
      },
      discard() {
        // noop
      },
    };
  }

  return {
    store() {
      try {
        const url = new URL(window.location.href);
        url.hash = `#${id}`;
        if (window.history.state?.[id] === true) {
          window.history.replaceState({[id]: true}, '', url);
        } else {
          window.history.pushState({[id]: true}, '', url);
        }
      } catch {
        // ignore
      }
    },
    discard() {
      try {
        if (window.history.state?.[id] === true) {
          const url = new URL(window.location.href);
          url.hash = '';
          window.history.replaceState({[id]: true}, '', url);
        }
      } catch {
        // ignore
      }
    },
  };
};
